package com.taager.tracking.event

data class BaseErrorTrackingEvent(val message: String) :
    BaseTrackingEvent(event = "error", extras = mapOf("message" to message))
